import styled from 'styled-components';
import { rem } from 'polished';

const baseFont = '12px';
const S = {};

const FwSemibold = ({theme:{$fwSemibold}}) => `${$fwSemibold}`;
const FwRegular = ({theme:{$fwRegular}}) => `${$fwRegular}`;

const InputErrorColor = ({theme: {$inputErrorColor}}) => `${$inputErrorColor}`;
const InputColor = ({theme: {$inputColor}}) => `${$inputColor}`;
const InputActiveColor = ({theme: {$inputActiveColor}}) => `${$inputActiveColor}`;
const InputLabelColor = ({theme: {$inputLabelColor}}) => `${$inputLabelColor}`;
const InputPlaceholderColor = ({theme: {$inputPlaceholderColor}}) => `${$inputPlaceholderColor}`;
const InputBackgroundColor = ({theme: {$inputBackgroundColor}}) => `${$inputBackgroundColor}`;
const SubmitButtonTextColor = ({theme: {$submitButtonTextColor}}) => `${$submitButtonTextColor}`;
const FooterTextColor = ({theme: {$footerTextColor}}) => `${$footerTextColor}`;
const CheckedCheckboxColor = ({theme: {$checkedCheckboxColor}}) => `${$checkedCheckboxColor}`;
const CheckboxBorderColor = ({theme: {$checkboxBorderColor}}) => `${$checkboxBorderColor}`;
const LabelTextColor = ({theme: {$labelTextColor}}) => `${$labelTextColor}`;
const InfoBorderColor = ({theme: {$infoBorderColor}}) => `${$infoBorderColor}`;
const SubmissionErrorBackgroundColor = ({theme: {$submissionErrorBackgroundColor}}) => `${$submissionErrorBackgroundColor}`;

S.FormStep3 = styled.form`
    width: ${rem('400px', baseFont)};
    margin: 0 auto;
`;

S.InputsSection = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${rem('16px', baseFont)};
    width: 100%;
    margin-bottom: ${rem('32px', baseFont)};
`;

S.ConsentsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem('12px', baseFont)};
`;

S.InputWrapper = styled.div` 
    position: relative; 
    width: 100%; 
`;

S.Input = styled.input`
    width: 100%;
    height: ${rem('40px', baseFont)};
    padding: 0 ${rem('16px', baseFont)};
    font-size: ${rem('14px', baseFont)};
    border-radius: 4px;
    background: ${InputBackgroundColor};
    transition: border-color 0.2s;

    border: 1px solid ${props => props.hasError ? InputErrorColor : InputColor};

    &:focus {
        outline: none;
        border-color: ${props => props.hasError ? InputErrorColor : InputColor};
    }

    &:disabled {
        color: ${InputPlaceholderColor};
        cursor: not-allowed;
        border-color: ${InputColor};
    }

    &::placeholder {
        color: ${InputPlaceholderColor};
    }
`;

S.PasswordToggler = styled.button`
    position: absolute;
    right: ${rem('12px', baseFont)};
    top: ${rem('14px', baseFont)};
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    z-index: 2;
`;

S.PasswordTogglerIcon = styled.i`
    color: ${props => props.isActive ? InputActiveColor : InputColor};
    width: ${rem('16px', baseFont)};
    height: ${rem('16px', baseFont)};
    font-size: ${rem('16px', baseFont)};
`;

S.FloatingLabel = styled.span`
    position: absolute;
    top: -8px; left: 12px;
    background: ${InputBackgroundColor};
    padding: 0 4px;
    font-size: ${rem('10px', baseFont)};
    color: ${InputLabelColor};
    z-index: 1;
`;

S.CheckIcon = styled.span` 
    color: ${InputLabelColor};
    font-size: ${rem('16px', baseFont)}; 
`;

S.ErrorText = styled.div` 
    color: ${InputErrorColor};
    font-size: 10px; 
`;

S.CheckboxRow = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem('12px', baseFont)};
`;

S.CheckboxWrapper = styled.div` 
    flex-shrink: 0; 
`;

S.HiddenInput = styled.input` 
    position: absolute; 
    opacity: 0; 
    width: 0; 
`;

S.FakeCheckbox = styled.label`
    width: ${rem('18px', baseFont)};
    height: ${rem('18px', baseFont)};
    border: 1px solid ${props => props.checked ? CheckedCheckboxColor : CheckboxBorderColor};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

S.CheckMark = styled.span` 
    font-size: ${rem('14px', baseFont)}; 
    font-weight: 900; 
    color: ${CheckedCheckboxColor};
`;

S.Label = styled.label` 
    font-size: ${rem('12px', baseFont)}; 
    color: ${LabelTextColor}; 
    cursor: pointer; 
    font-weight: ${FwRegular};
`;

S.LabelPart = styled.span` 
    display: block; 
`;

S.Details = styled.details` 
    margin-top: 4px; 
`;

S.Summary = styled.summary`
    font-weight: ${FwSemibold}; 
    color: ${InputErrorColor}; 
    cursor: pointer; 
    list-style: none;
    outline: none;

    &::-webkit-details-marker { display: none; }

    &:after { content: '${props => props.moreText}'; }

    details[open] & {
        margin-bottom: 8px;
        &:after { content: '${props => props.lessText}'; }
    }
`;

S.AdminInfo = styled.div` 
    font-size: ${rem('12px', baseFont)}; 
    color: ${LabelTextColor}; 
    margin: ${rem('12px', baseFont)} 0; 
    padding-bottom: ${rem('16px', baseFont)};
    border-bottom: 1px solid ${InfoBorderColor};
    width: 100%;
    line-height: 1.4;
`;

S.SubmitBtn = styled.button`
    width: 100%; 
    height: ${rem('40px', baseFont)};
    font-size: ${rem('14px', baseFont)};
    background-color: ${InputErrorColor};
    color: ${SubmitButtonTextColor};
    border: none; 
    border-radius: 3px; 
    font-weight: ${FwSemibold};
    margin-top: 24px; 
    cursor: pointer; 
    text-transform: uppercase;
    
    &:disabled { 
        opacity: 0.6; 
        cursor: not-allowed; 
    }
`;

S.FooterInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem('4px')};
    margin-top: ${rem('24px', baseFont)};
    text-align: center;
`;

S.ContactInfo = styled.div`
    font-size: ${rem('12px', baseFont)};
    color: ${FooterTextColor};
`;

S.ContactLink = styled.span`
    color: ${InputErrorColor};
    font-weight: ${FwSemibold};
    font-size: ${rem('12px', baseFont)};
    cursor: pointer;
`;

S.SubmissionError = styled.div`
    margin: 0;
    border-radius: .25rem;
    width: 100%;
    color: red;
    font-size: 1rem;
    text-align: left;
    padding: .83rem;
    background-color: ${SubmissionErrorBackgroundColor};
    margin-bottom: ${rem('20px', baseFont)};
`;

export default S;